import * as types from './actions';

export const initialState = {
  cars: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.PROFILECARS_SET:
      return { ...state, cars: payload.cars };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProfileCars/reducer.js